import React, { Component } from "react";
import { Grid, Row, Col, FormGroup, ControlLabel } from "react-bootstrap";

import auth from "../../services/authService";

import Card from "../../components/Card/Card.jsx";

import Button from "../../components/CustomButton/CustomButton.jsx";
import Input from "../../components/Common/input";
var base64 = require("base-64");
class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHidden: true,
      data: { username: "", password: "" },
      showError: false,
      blocked: false
    };
  }
  handleLogin = async () => {
    const { data } = this.state;
    const { data: log } = await auth.login(data.username, data.password);
    if (log.exist) {
      localStorage.setItem("user_report", data.username);
      localStorage.setItem("id_customer_report", data.username);
      localStorage.setItem("token_report", log.akses_token);
      localStorage.setItem(
        "akses_report",
        base64.encode(JSON.stringify(log.akses))
      );
      
      this.props.history.replace("/dashboard");
    } if(log.blocked){
      this.setState({ data: { username: "", password: "" }, blocked: log.blocked });
    } else {
      this.setState({ data: { username: "", password: "" }, showError: true });
    }
  };
  componentDidMount() {
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    const user = localStorage.getItem("user_report");
    if (user !== null) {
      this.props.history.replace("/dashboard");
    }
  }
  handleChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data });
  };
  handleSubmit = (e) => {
    if (e.key === "Enter") {
      this.handleLogin();
    }
  };
  render() {
    const { data, showError, blocked } = this.state;
    return (
      <Grid>
        <Row>
          <Col md={4} sm={6} mdOffset={4} smOffset={3}>
            <form onSubmit={this.handleSubmit}>
              <Card
                hidden={this.state.cardHidden}
                textCenter
                title="Login"
                content={
                  <div>
                    <FormGroup>
                      <ControlLabel>Email address</ControlLabel>
                      <Input
                        onKeyPress={this.handleSubmit}
                        onChange={this.handleChange}
                        placeholder="Enter email"
                        name="username"
                        value={data.username}
                      />
                      {showError && (
                        <small className="text-danger">
                          Username / Password Salah
                        </small>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Password</ControlLabel>
                      <Input
                        onKeyPress={this.handleSubmit}
                        onChange={this.handleChange}
                        placeholder="Password"
                        type="password"
                        name="password"
                        value={data.password}
                      />
                      {blocked && (
                        <small className="text-danger">
                          Akses terblokir. silahkan contact Admin
                        </small>
                      )}
                    </FormGroup>
                  </div>
                }
                legend={
                  <Button
                    onClick={() => {
                      this.handleLogin();
                    }}
                    bsStyle="info"
                    fill
                    wd
                  >
                    Login
                  </Button>
                }
                ftTextCenter
              />
            </form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx